import store from '../store';
import router from "./index";
export const guard = (to, from, next) => {
    if(store.state.user.user) {
        // or however you store your logged in state
        next(); // allow to enter route
    } else{
        next({name: "Login"}); // go to '/login';
    }
};

//Go to home if you logged in
export const unguard = (to, from, next) => {
    if(!store.state.user.user) {
        next(); // allow to enter route
    } else{
        next({name: "Home"});
    }
};

export const productsExists = (to, from, next) => {
    if(store.state.cart.cart.products.length) {
        next(); // allow to enter route
    } else{
        next({name: "Menu"});
    }
};

export const fixRoute = (to, from, next) => {
    if(to.params.business_id) {
        next(); // allow to enter route
    } else{
        router.push({name: to.name, params: {business_id : store.state.shared.businessId}});
    }
};
